import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { DashboardEdit } from "../../../assets/icons";
import { renderTableMergersAndAcquisitions } from "../dashboard-util/dashboard-utils";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";

const CustomModal = ({
    type,
    selectedMember,
    key,
    showState,
    onHideFunction
}) => {
    const taskID = selectedMember.DealsTaskId;
    const allowEdit = selectedMember.AllowDealsEdit;
    const tableData = selectedMember.TableDeals;
    const taskName = `Time Tracker - ${(type.toLowerCase() === "associate" ? "Associate" : "Analyst")}`;
    const renderTable = renderTableMergersAndAcquisitions;

    return (
        selectedMember && (
        <Modal
            key={key}
            show={showState}
            onHide={onHideFunction}
            contentClassName="deal-and-vacation-date-healthcare-modal-styles"
            dialogClassName="deal-and-vacation-date-healthcare-modal"
            backdropClassName="healthcare-modal-backdrop"
            scrollable={true}
        >
            <div className="popup-week healthcare-deal">
            <Modal.Header className="header-popup" closeButton>
                <div className="healthcare-deal-task-name">
                {taskName}
                <div className="healthcare-deal-user-name">{selectedMember.Name}</div>
                </div>
            </Modal.Header>
            <hr></hr>
            { allowEdit && (
                <div className="healthcare-edit-button-container">
                <div>
                    <Link to={`/tasks/edit/std/${taskID}`} target="_blank" rel='noopener noreferrer'>
                    <div className="healthcare-edit">
                        <img alt="dropdown-arrow" src={DashboardEdit} />
                        Edit Table
                    </div>
                    </Link>
                </div>
                </div>
            )}
            <Modal.Body className="header-body">
                {renderTable(tableData)}
            </Modal.Body>
            </div>
        </Modal>
        )
    );
};

CustomModal.propTypes = {
    type: PropTypes.oneOf(['associate', 'analyst']).isRequired,
    modalType: PropTypes.oneOf(['vacation', 'deals']).isRequired,
    selectedMember: PropTypes.shape({
      VacationsTaskId: PropTypes.number,
      DealsTaskId: PropTypes.number,
      AllowVacationsEdit: PropTypes.bool,
      AllowDealsEdit: PropTypes.bool,
      TableVacation: PropTypes.array,
      TableDeals: PropTypes.array,
      Name: PropTypes.string.isRequired
    }).isRequired,
    showState: PropTypes.bool.isRequired,
    onHideFunction: PropTypes.func.isRequired
  };

export default CustomModal;
